/* src/components/Position.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	binding_callbacks,
	children,
	claim_element,
	claim_space,
	claim_text,
	component_subscribe,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	set_data,
	space,
	text
} from "../_snowpack/pkg/svelte/internal.js";

import { session } from "../_app/assets/runtime/app/stores.js";

function create_fragment(ctx) {
	let div1;
	let span;
	let t0_value = /*position*/ ctx[0].acronym + "";
	let t0;
	let t1;
	let div0;
	let t2_value = /*position*/ ctx[0].name + "";
	let t2;
	let div0_class_value;
	let div1_class_value;

	return {
		c() {
			div1 = element("div");
			span = element("span");
			t0 = text(t0_value);
			t1 = space();
			div0 = element("div");
			t2 = text(t2_value);
			this.h();
		},
		l(nodes) {
			div1 = claim_element(nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			span = claim_element(div1_nodes, "SPAN", {});
			var span_nodes = children(span);
			t0 = claim_text(span_nodes, t0_value);
			span_nodes.forEach(detach);
			t1 = claim_space(div1_nodes);
			div0 = claim_element(div1_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			t2 = claim_text(div0_nodes, t2_value);
			div0_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div0, "class", div0_class_value = "block z-50 rounded-sm px-2 py-1 pointer-events-none opacity-0 group-hover:opacity-100 focus:opacity-100 transition-opacity shadow border text-xs absolute whitespace-nowrap left-1/2 transform bottom-6 text-center -translate-x-1/2 " + /*colors*/ ctx[2]);
			attr(div1, "class", div1_class_value = "cursor-default group relative rounded border px-1 inline-block align-middle " + /*colors*/ ctx[2]);
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, span);
			append(span, t0);
			append(div1, t1);
			append(div1, div0);
			append(div0, t2);
			/*div0_binding*/ ctx[5](div0);
		},
		p(ctx, [dirty]) {
			if (dirty & /*position*/ 1 && t0_value !== (t0_value = /*position*/ ctx[0].acronym + "")) set_data(t0, t0_value);
			if (dirty & /*position*/ 1 && t2_value !== (t2_value = /*position*/ ctx[0].name + "")) set_data(t2, t2_value);

			if (dirty & /*colors*/ 4 && div0_class_value !== (div0_class_value = "block z-50 rounded-sm px-2 py-1 pointer-events-none opacity-0 group-hover:opacity-100 focus:opacity-100 transition-opacity shadow border text-xs absolute whitespace-nowrap left-1/2 transform bottom-6 text-center -translate-x-1/2 " + /*colors*/ ctx[2])) {
				attr(div0, "class", div0_class_value);
			}

			if (dirty & /*colors*/ 4 && div1_class_value !== (div1_class_value = "cursor-default group relative rounded border px-1 inline-block align-middle " + /*colors*/ ctx[2])) {
				attr(div1, "class", div1_class_value);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div1);
			/*div0_binding*/ ctx[5](null);
		}
	};
}

function clamp(node) {
	// reset baseline
	node.style.setProperty("--tw-translate-x", "-50%");

	const { scrollWidth } = document.body;
	const { left, right } = node.getBoundingClientRect();

	if (left < 16) {
		node.style.setProperty("--tw-translate-x", `calc(-50% + ${16 - left}px)`);
	} else if (right > scrollWidth - 16) {
		node.style.setProperty("--tw-translate-x", `calc(-50% - ${right - (scrollWidth - 16)}px)`);
	}
}

function instance($$self, $$props, $$invalidate) {
	let corePositions;
	let $session;
	component_subscribe($$self, session, $$value => $$invalidate(4, $session = $$value));

	const colorPalette = [
		"bg-red-100 text-red-800 border-red-200",
		"bg-yellow-100 text-yellow-800 border-yellow-200",
		"bg-green-100 text-green-800 border-green-200",
		"bg-blue-100 text-blue-800 border-blue-200",
		"bg-indigo-100 text-indigo-800 border-indigo-200",
		"bg-purple-100 text-purple-800 border-purple-200",
		"bg-pink-100 text-pink-800 border-pink-200"
	];

	let { position } = $$props;
	let colors = "";

	/**
 * @type {HTMLElement | undefined}
 */
	let tooltip;

	function computeColor() {
		const paletteIndex = corePositions.indexOf(position.acronym);

		if (paletteIndex < 0) {
			$$invalidate(2, colors = "bg-gray-100 text-gray-800 border-gray-200");
		} else {
			$$invalidate(2, colors = colorPalette[paletteIndex]);
		}
	}

	function div0_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			tooltip = $$value;
			$$invalidate(1, tooltip);
		});
	}

	$$self.$$set = $$props => {
		if ("position" in $$props) $$invalidate(0, position = $$props.position);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*$session*/ 16) {
			$: $$invalidate(3, corePositions = $session.corePositions || []);
		}

		if ($$self.$$.dirty & /*corePositions*/ 8) {
			$: (corePositions, computeColor());
		}

		if ($$self.$$.dirty & /*tooltip*/ 2) {
			$: if (tooltip) {
				clamp(tooltip);
			}
		}
	};

	return [position, tooltip, colors, corePositions, $session, div0_binding];
}

class Position extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { position: 0 });
	}
}

export default Position;
//# sourceMappingURL=Position.svelte.js.map
